import { getStoreKeyByName } from "../Steps";

const nameStoreFormValue = getStoreKeyByName('usage')

const shareCollectInfo = [
  {
    id: 'withUserConsent',
    label: 'With user consent',
    value: false,
    isCustom: false,
  },
  {
    id: 'forTransfersOfBusiness',
    label: 'For transfers of business',
    value: false,
    isCustom: false,
  },
  {
    id: 'sharingWithAffiliates',
    label: 'Sharing with affiliates',
    value: false,
    isCustom: false,
  },
  {
    id: 'sharingWithOtherUsers',
    label: 'Sharing with other users',
    value: false,
    isCustom: false,
  },
]


const defaultValue = {
  shareCollectInfo: shareCollectInfo,
  isPersonalDataTransferedToThirdCountry: false,
  thirdPartyLegalBasis: '',
  thirdPartyCountries: [],
  thirdPartyCustomLegalBasis: '',
}

export const usageFormState = set =>  ({
  [nameStoreFormValue]:  defaultValue,
  setUsageFormValue: value => set({ [nameStoreFormValue]: value}),
  resetUsageFormData: () => set({ [nameStoreFormValue]: defaultValue  }),
})